<template>
  <div class="notifications-page">
    <h1>{{ $t('SidebarMenu.Menu93') }}</h1>
    <div class="notifications-body">
      <el-form :model="notificationsform" size="mini" label-width="150px" ref="notificationsform">
        <el-form-item :label="$t('new.t22')">
          <el-col :span="8">
            <el-select v-model="taskid" @change="wechatobj=[]; getEmails()" style="width:100%;">
              <el-option 
                v-for="item in brands" 
                :key="item.taskid" 
                :label="item.name" 
                :value="item.taskid"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('new.t23')" prop="type">
          <el-checkbox-group v-model="notificationsform.type" @change="setEmail('notificationsform', true)">
            <div class="notifications-body-checkitem">
              <el-checkbox label="3" name="notificationsformtype">{{ $t('new.t24') }}</el-checkbox>
              <span>{{ $t('new.t27') }}</span>
            </div>
            <div class="notifications-body-checkitem">
              <el-checkbox label="2" name="notificationsformtype">{{ $t('new.t25') }}</el-checkbox>
              <span>{{ $t('new.t28') }}</span>
            </div>
            <div class="notifications-body-checkitem">
              <el-checkbox label="1" name="notificationsformtype">{{ $t('new.t26') }}</el-checkbox>
              <span>{{ $t('new.t29') }}</span>
            </div>
            <div class="notifications-body-checkitem" v-if="showtips">
              <el-alert
                :title="$t('new.t30')"
                type="error"
                :closable="false"
                :description="$t('new.t31')">
              </el-alert>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          v-for="(email, index) in notificationsform.email"
          :label='email.label'
          :key="email.key"
          :prop="'email.' + index + '.value'"
          :rules="[
            { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }
          ]"
        >
          <el-col :span="8">
            <el-input v-model="email.value" clearable></el-input>
          </el-col>
          <el-col :span="8" class="notificationsformbtngroup">
            <el-button v-if="email.lock" @click="addEmailBox('notificationsform')" :disabled="notificationsform.email.length >= 5 || email.value == ''">
              <i class="el-icon-circle-plus"></i>
            </el-button>
            <el-button v-if="!email.lock" @click="addEmail('notificationsform')" :disabled="notificationsform.email.length > 5 || email.value == ''">
              <i class="el-icon-success"></i>
            </el-button>
            <el-button :disabled="notificationsform.email.length == 1 && email.value == ''" @click.prevent="removeEmail(email, 'notificationsform')">
              <i class="el-icon-remove"></i>
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('new.t33')" class="wechatlists">
          <el-tag
            v-for="(tag, index) in wechatobj"
            :key="index"
            closable
            :disable-transitions="false"
            @close="unSetwechat(tag, function(){setEmail('notificationsform', true)})" size="medium">
            {{ tag.nickname }}
          </el-tag>          
          <el-button 
            :disabled="notificationsform.type.length == 0 || (notificationsform.type.length == 1 &&notificationsform.type[0] == 0)" v-if="wechatobj.length < 5" 
            type="success" 
            @click="setWechat(); getWechatType()"
          >
            {{ $t('new.t34') }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="showqrcode">
          <img style="margin-left: -10px; margin-top: -10px;" width="150" :src="qrcode" />
          <p style="margin-bottom: 0; margin-top: -10px;">使用微信扫一扫关注公众号后绑定</p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      subid: this.$route.params.Id,
      taskid: '',
      wechatobj: [],
      notificationsform: {
        type: [],
        wechat: [],
        email: [{
          value: '',
          label: this.$t('new.t32')
        }],
      },
      brands: [],
      qrcode: '',
      showqrcode: false,
      timer: '',
      showtips: false
    }
  },

  mounted(){
    let that = this
    let _price = JSON.parse(localStorage.getItem("price")).val
    that.brands = _price
    _price.map(item => {
      if(item.subid == that.subid){
         that.taskid = item.taskid
      }
    })
    that.getEmails()
  },

  methods: {

    /**
     * 新增
     */
    addEmailBox(f) {
      let that = this
      that.$refs[f].validate((valid) => {
        if(valid){
          that.getEmails(function(){
            that.notificationsform.email.push({
              value: '',
              label: " ",
              key: Date.now(),
              lock: false
            })
          })
        }
      })
    },
    addEmail(f) {
      this.$refs[f].validate((valid) => {
        if(valid){
          this.setEmail(f, false)
        }
      })
    },
    
    /**
     * 移除
     */
    removeEmail(item, f) {
      var index = this.notificationsform.email.indexOf(item)
      if(index !== -1) {
        this.notificationsform.email.splice(index, 1)
      }
      if(this.notificationsform.email.length == 0){
        this.notificationsform.email = [{
          value: '',
          label: this.$t('new.t32')
        }]
      }
      this.notificationsform.email[0].label = this.$t('new.t32')
      this.setEmail(f, true)
    },

    /**
     * 提交
     */
    setEmail: function(formName, isdelete){
      let that = this
      let emails = that.notificationsform.email
      let emailsarr = []
      for(let i=0; i<emails.length; i++){
        emailsarr[i] = emails[i].value
      }
      that.notificationsform.wechat = that.wechatobj.map(item => {
        return item.openid
      })
      let url = that.API_URL + '/v3/notification/settimedtask'
      let _query = {
        taskid: that.taskid,
        type: (that.notificationsform.type).join(','),
        wechat: that.notificationsform.wechat.length > 0 ? JSON.stringify(that.notificationsform.wechat) : '',
        email: emailsarr.length == 1 && emailsarr[0] == '' ? '' : JSON.stringify(emailsarr),
        cycle: '',
        parameter: ''
      }
      if(isdelete == false){
        that.$refs[formName].validate((valid) => {
          if (valid) {
            $.ajax({
              url: url,
              type: "POSt",
              headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
              changeOrigin: true,
              crossDomain: true,
              data: _query,
              success: function(data) {
                console.log(data)
                that.$message({
                  type: 'success',
                  message: '通知设定成功！'
                })
                that.getEmails(function(){
                  // that.notificationsform.email.push({
                  //   value: '',
                  //   label: " ",
                  //   key: Date.now(),
                  //   lock: false
                  // })
                })
              },
              error: function(response) {
                console.log(response)
              }
            })
          } else {
            return false
          }
        })
      }else{
        $.ajax({
          url: url,
          type: "POST",
          headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
          changeOrigin: true,
          crossDomain: true,
          data: _query,
          success: function(data) {
            console.log(data)
            that.$message({
              type: 'success',
              message: '通知设定成功！'
            })
            that.getEmails()
          },
          error: function(response) {
            console.log(response)
          }
        })        
      }

    },

    /**
     * 获取邮箱
     */
    getEmails: function(callback){
      let that = this
      let url = that.API_URL + '/v3/notification/timedtaskview?taskid=' + that.taskid
      let _wxobjlength = JSON.parse(JSON.stringify(that.wechatobj)).length
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          if(data.result.length > 0){
            that.notificationsform.type = data.result.map(item => {
              return item.type
            })
            if(that.notificationsform.type.length == 1 && that.notificationsform.type[0] == 0){
              that.showtips = true
            }else{
              that.showtips = false
            }
            
            let _mm = []
            for(let m=0; m<that.notificationsform.type.length; m++){
              if(that.notificationsform.type[m] != 0){
                _mm.push(that.notificationsform.type[m])
              }
            }
            that.notificationsform.type = _mm
            
            let _e = data.result[0].email
            let _email = []
            if(_e != '' && _e != null){
              let resc0 = _e.substr(1)
              let resc1 = resc0.substr(0, resc0.length-1)
              let resc2 = JSON.parse(resc1)
              for(let i=0; i<resc2.length; i++){
                let _obj = {
                  value: resc2[i],
                  label: i == 0 ? that.$t('new.t32') : '',
                  key: 'email' + i,
                  lock: true
                }
                _email.push(_obj)
              }
            }else{
              _email = [{
                value: '',
                label: that.$t('new.t32')
              }]
            }

            let _w = data.result[0].wechat
            if(_w!=''&&_w!=null){
              let wresc0 = _w.substr(1)
              let wresc1 = wresc0.substr(0, wresc0.length-1)
              let wresc2 = JSON.parse(wresc1)
              let _wx = []
              for(let j=0; j<wresc2.length; j++){
                _wx.push(wresc2[j])
              }
              that.notificationsform.wechat = _wx
            }

            let _wxobj = []
            for(let i=0; i<data.result[0].nickname.length; i++){
              if(data.result[0].nickname[i] != ''){
                let _o = {
                  nickname: data.result[0].nickname[i],
                  openid: that.notificationsform.wechat[i]
                }
                _wxobj.push(_o)
              }
            }
            if(_wxobj.length > _wxobjlength){
              that.timer = window.clearInterval(that.timer)
              that.showqrcode = false
            }
            that.wechatobj = _wxobj

            that.notificationsform.email = _email
            if(callback){
              if(_email.length<5){
                callback()
              }
            }
          }else{
            that.notificationsform.type = []
            that.notificationsform.wechat = []
            that.notificationsform.email = [{
              value: '',
              label: that.$t('new.t32')
            }]
            that.showtips = true
          }
        },
        error: function(response) {
          console.log('getEmails', response)
        }
      })
    },

    /**
     * 微信
     */
    setWechat: function(){
      let that = this
      let url = that.API_URL + '/v3/task/wechat/authentication?taskid=' + that.taskid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          that.qrcode = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + data.ticket
          that.showqrcode = true
        },
        error: function(response) {
          console.log('setWechat', response)
        }
      })
    },

    /**
     * 取消微信绑定
     */
    unSetwechat: function(tag, callback){
      this.wechatobj.splice(this.wechatobj.indexOf(tag), 1)
      this.notificationsform.wechat.splice(this.notificationsform.wechat.indexOf(tag.openid), 1)
      let that = this
      let url = that.API_URL + '/v3/task/wechat/delwechat?taskid=' + that.taskid + '&openid=' + tag.openid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          console.log(data)
          callback()
        },
        error: function(response) {
          console.log('setWechat', response)
        }
      })
    },

    /**
     * 定时器
     */
    getWechatType: function(){
      this.timer = setInterval(this.getEmails, 10000)
    },

  },

  beforeDestroy() {
    clearInterval(this.getWechatType)
  }
}
</script>